import { render, staticRenderFns } from "./OrderLifeCycleComponent.vue?vue&type=template&id=53687ef3&"
import script from "./OrderLifeCycleComponent.vue?vue&type=script&lang=js&"
export * from "./OrderLifeCycleComponent.vue?vue&type=script&lang=js&"
import style0 from "./OrderLifeCycleComponent.vue?vue&type=style&index=0&id=53687ef3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports